import React, { Component } from 'react'
import {
    Form,
    Card,
    Button,
    Input,
    Radio,
    Upload,
    Divider,
    Switch,
    Select,
    Table,
    Space,
    Popconfirm,
    message
} from 'antd'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import {
    VerticalAlignTopOutlined,
    EditTwoTone,
    DeleteTwoTone,
    PlusOutlined,
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    UploadOutlined,
    DeleteOutlined
} from '@ant-design/icons'
import {
    getHeaderConfig,
    setHeaderConfig,
    uploadImage
} from '../../../services/apiServices'
import RowLayout from '../../../commons/RowLayout/RowLayout'
import LoadingModal from '../../../commons/Modal/Loading'
import SaveButton from './../../../commons/Button/SaveButton'
import TopbarMenuModal from './TopbarMenuModal'

const { Option } = Select

const Container = styled(Card)`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 400px;
        }
    }
    .header-image-wrapper {
        cursor: pointer;
        display: flex;
        max-width: 500px;
        margin-bottom: 15px;
        &:hover {
            opacity: 0.8;
        }
        &.selected {
            border: 3px solid #1890ff !important;
        }

        img {
            width: 100%;
        }
    }
    .radio-y {
        display: block;
        height: 30px;
        line-height: 30px;
    }
`

const BackgroundPreview = styled.div`
    margin-bottom: 34px;
    height: 120px;
    border-radius: 2px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    background-size: cover;
    background-position: center;
    background-image: url(${props => props.image});
    background-size: ${props => props.size};
`

const headerDesktops = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 },
    { id: 6 }
]

const headerMobiles = [{ id: 1 }, { id: 2 }, { id: 3 }]

const headerBackgroundStyles = ['auto', 'contain', 'cover']

class HeaderGeneral extends Component {
    state = {
        isLoading: false,
        headerDesktopStyle: 1,
        headerMobileStyle: 1,
        headerBackgroundImage: '',
        headerBackgroundImageStyle: 'auto',
        headerConfig: {},
        isOpenWishlistXs: false,
        isOpenWishlistLg: false,
        topbarLeft: [],
        topbarRight: [],
        isOpenTopbar: false,
        isOpenTopbarMenuModal: false,
        selectedTopbarIndex: -1,
        selectedTopbarInfo: {},
        selectedTopbarSide: 'LEFT'
    }

    formRef = React.createRef()

    componentDidMount() {
        this.getHeaderConfig()
    }

    onFinish(values) {
        let data = {
            style_lg: this.state.headerDesktopStyle,
            style_xs: this.state.headerMobileStyle,
            background_image_lg: this.state.headerBackgroundImage,
            background_image_style_lg: this.state.headerBackgroundImageStyle,
            topbar_left: this.state.topbarLeft,
            topbar_right: this.state.topbarRight,
            enable_topbar: values.enableTopbar,
            open_cat_menu_home: values.openCatMenuHome,
            enable_categories_menu_lg: values.enableCategoriesMenuLg,
            enable_logo_lg: values.enableLogoLg,
            enable_search_lg: values.enableSearchLg,
            enable_account_lg: values.enableAccountLg,
            enable_wishlist_lg: values.enableWishlistLg,
            enable_cart_lg: values.enableCartLg,
            additional_element: values.additionalElement,
            enable_categories_menu_xs: values.enableCategoriesMenuXs,
            enable_logo_xs: values.enableLogoXs,
            enable_search_xs: values.enableSearchXs,
            enable_account_xs: values.enableAccountXs,
            enable_wishlist_xs: values.enableWishlistXs,
            enable_cart_xs: values.enableCartXs,
            wishlist_url: values.wishlistUrl,
            search_only_product: values.searchOnlyProduct
        }
        this.setHeaderConfig(data)
    }

    onChangeHeaderDesktop(style) {
        this.setState({ headerDesktopStyle: style })
    }

    onChangeHeaderMobile(style) {
        this.setState({ headerMobileStyle: style })
    }

    onChangeHeaderBackgroundImage(e) {
        this.uploadImage(e.file.originFileObj, image => {
            this.setState({ headerBackgroundImage: image })
        })
    }

    onChangeHeaderBackgroundStyle(style) {
        this.setState({ headerBackgroundImageStyle: style })
    }

    onRemoveHeaderBackgroundImage() {
        this.setState({ headerBackgroundImage: '' })
    }

    toggleWishlist(type, status) {
        if (type == 'mobile') {
            this.setState({
                isOpenWishlistXs: status
            })
        } else {
            this.setState({
                isOpenWishlistLg: status
            })
        }
    }

    toggleTopbar(status) {
        this.setState({
            isOpenTopbar: status
        })
    }

    toggleTopbarMenuModal(status, onSuccess) {
        this.setState(
            {
                isOpenTopbarMenuModal: status
            },
            () => {
                onSuccess && onSuccess()
            }
        )
    }

    async getHeaderConfig() {
        this.setState({ isLoading: true })
        try {
            let headerConfig = await getHeaderConfig()
            this.setState({
                isLoading: false,
                headerConfig,
                headerDesktopStyle: headerConfig.style_lg,
                headerMobileStyle: headerConfig.style_xs,
                headerBackgroundImage: headerConfig.background_image_lg,
                headerBackgroundImageStyle:
                    headerConfig.background_image_style_lg || 'auto',
                isOpenWishlistXs: headerConfig.enable_wishlist_xs,
                isOpenWishlistLg: headerConfig.enable_wishlist_lg,
                isOpenTopbar: headerConfig.enable_topbar,
                topbarLeft: headerConfig.topbar_left,
                topbarRight: headerConfig.topbar_right
            })
            this.formRef.current &&
                this.formRef.current.setFieldsValue({
                    // desktop
                    enableTopbar: headerConfig.enable_topbar,
                    openCatMenuHome: headerConfig.open_cat_menu_home,
                    enableCategoriesMenuLg:
                        headerConfig.enable_categories_menu_lg,
                    enableLogoLg: headerConfig.enable_logo_lg,
                    enableSearchLg: headerConfig.enable_search_lg,
                    enableAccountLg: headerConfig.enable_account_lg,
                    enableWishlistLg: headerConfig.enable_wishlist_lg,
                    enableCartLg: headerConfig.enable_cart_lg,
                    additionalElement: headerConfig.additional_element,
                    // mobile
                    enableCategoriesMenuXs:
                        headerConfig.enable_categories_menu_xs,
                    enableLogoXs: headerConfig.enable_logo_xs,
                    enableSearchXs: headerConfig.enable_search_xs,
                    enableAccountXs: headerConfig.enable_account_xs,
                    enableWishlistXs: headerConfig.enable_wishlist_xs,
                    enableCartXs: headerConfig.enable_cart_xs,

                    wishlistUrl: headerConfig.wishlist_url,
                    searchOnlyProduct: headerConfig.search_only_product
                })
        } catch (error) {
            console.log(error)
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setHeaderConfig(data) {
        this.setState({ isLoading: true })
        try {
            await setHeaderConfig({
                body: {
                    config: data
                }
            })
            this.setState({
                isLoading: false
            })
            message.success(this.props.T('SAVED'))
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async uploadImage(file, onSuccess) {
        this.setState({ isLoading: true })
        try {
            let { image } = await uploadImage({ body: { file } })
            this.setState({ isLoading: false })
            onSuccess && onSuccess(image)
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onOpenEditTopbarMenu(side = 'LEFT', index = -1) {
        let state = {
            isOpenTopbarMenuModal: true,
            selectedTopbarSide: side,
            selectedTopbarIndex: index
        }
        if (index != -1) {
            if (side == 'LEFT') {
                state.selectedTopbarInfo = this.state.topbarLeft[index]
            } else {
                state.selectedTopbarInfo = this.state.topbarRight[index]
            }
            this.setState(state)
        } else {
            state.selectedTopbarInfo = {}
            this.setState(state)
        }
    }

    onSaveEditTopbarMenu(info = {}) {
        let index = this.state.selectedTopbarIndex
        let side = this.state.selectedTopbarSide

        let state = {
            isOpenTopbarMenuModal: false,
            selectedTopbarSide: '',
            selectedTopbarIndex: -1,
            selectedTopbarInfo: {}
        }

        let menus = []

        if (index != -1) {
            if (side == 'LEFT') {
                menus = cloneDeep(this.state.topbarLeft)
                menus[index] = info
                state.topbarLeft = menus
            } else {
                menus = cloneDeep(this.state.topbarRight)
                menus[index] = info
                state.topbarRight = menus
            }
            this.setState(state)
        } else {
            if (side == 'LEFT') {
                menus = cloneDeep(this.state.topbarLeft)
                menus.push(info)
                state.topbarLeft = menus
            } else {
                menus = cloneDeep(this.state.topbarRight)
                menus.push(info)
                state.topbarRight = menus
            }
            this.setState(state)
        }
    }

    onRemoveTopbarMenu(side = 'LEFT', index = 0) {
        let state = {}
        let menus = []
        if (side == 'LEFT') {
            menus = cloneDeep(this.state.topbarLeft)
            menus.splice(index, 1)
            state.topbarLeft = menus
        } else {
            menus = cloneDeep(this.state.topbarRight)
            menus.splice(index, 1)
            state.topbarRight = menus
        }
        this.setState(state)
    }

    render() {
        let { T } = this.props

        return (
            <Form ref={this.formRef} onFinish={this.onFinish.bind(this)}>
                <Container
                    title={
                        <span className="text-xl">
                            <VerticalAlignTopOutlined /> {T('HEADER')} -{' '}
                            {T('GENERAL')}
                        </span>
                    }>
                    <Divider orientation="left">{T('DESKTOP')}</Divider>

                    <RowLayout title={T('STYLE')}>
                        <Form.Item>
                            {headerDesktops.map(header => (
                                <div
                                    className={`header-image-wrapper ${
                                        header.id ==
                                        this.state.headerDesktopStyle
                                            ? 'selected'
                                            : ''
                                    }`}
                                    style={{
                                        border: '2px solid #ddd'
                                    }}
                                    key={header.id}
                                    onClick={() =>
                                        this.onChangeHeaderDesktop(header.id)
                                    }>
                                    <img
                                        src={`${window.config.themeUrl}/manager/static/images/layout-header-lg/${header.id}.jpg`}
                                    />
                                </div>
                            ))}
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('BACKGROUND_IMAGE')}>
                        <Form.Item>
                            <Space>
                                <Upload
                                    accept="image/gif, image/jpeg, image/png, image/webp"
                                    fileList={[]}
                                    customRequest={() => {}}
                                    onChange={e =>
                                        this.onChangeHeaderBackgroundImage(e)
                                    }>
                                    <Button type="primary">
                                        <UploadOutlined /> {T('UPLOAD')}
                                    </Button>
                                </Upload>
                                {this.state.headerBackgroundImage && (
                                    <Popconfirm
                                        placement="top"
                                        title={T('CONFIRM_REMOVE_MENU_MSG')}
                                        onConfirm={() =>
                                            this.onRemoveHeaderBackgroundImage()
                                        }
                                        okText={T('YES')}
                                        cancelText={T('NO')}>
                                        <Button
                                            type="primary"
                                            danger
                                            icon={<DeleteOutlined />}></Button>
                                    </Popconfirm>
                                )}
                            </Space>
                        </Form.Item>
                    </RowLayout>

                    {this.state.headerBackgroundImage && (
                        <RowLayout title={T('BACKGROUND_IMAGE_STYLE')}>
                            <Form.Item>
                                <Select
                                    value={
                                        this.state.headerBackgroundImageStyle
                                    }
                                    style={{ width: 120 }}
                                    onChange={this.onChangeHeaderBackgroundStyle.bind(
                                        this
                                    )}>
                                    {headerBackgroundStyles.map(item => (
                                        <Option key={item} value={item}>
                                            {item}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </RowLayout>
                    )}

                    {this.state.headerBackgroundImage && (
                        <RowLayout title={T('EXAMPLE_BACKGROUND')}>
                            <BackgroundPreview
                                size={this.state.headerBackgroundImageStyle}
                                image={this.state.headerBackgroundImage}
                            />
                        </RowLayout>
                    )}

                    <RowLayout title={T('ENABLE_TOPBAR')}>
                        <Form.Item name="enableTopbar" valuePropName="checked">
                            <Switch onChange={val => this.toggleTopbar(val)} />
                        </Form.Item>
                    </RowLayout>

                    {this.state.isOpenTopbar && (
                        <RowLayout title={T('TOPBAR_MENU')}>
                            <TopbarMenus
                                T={T}
                                side="LEFT"
                                menus={this.state.topbarLeft}
                                onOpenEdit={this.onOpenEditTopbarMenu.bind(
                                    this
                                )}
                                onRemove={this.onRemoveTopbarMenu.bind(this)}
                            />
                            <TopbarMenus
                                T={T}
                                side="RIGHT"
                                menus={this.state.topbarRight}
                                onOpenEdit={this.onOpenEditTopbarMenu.bind(
                                    this
                                )}
                                onRemove={this.onRemoveTopbarMenu.bind(this)}
                            />
                        </RowLayout>
                    )}

                    <TopbarMenuModal
                        T={T}
                        info={this.state.selectedTopbarInfo}
                        isOpen={this.state.isOpenTopbarMenuModal}
                        onCancel={() => this.toggleTopbarMenuModal(false)}
                        onOk={this.onSaveEditTopbarMenu.bind(this)}
                    />

                    <RowLayout title={T('ENABLE_LOGO')}>
                        <Form.Item name="enableLogoLg" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_SEARCH_BOX')}>
                        <Form.Item
                            name="enableSearchLg"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_ACCOUNT')}>
                        <Form.Item
                            name="enableAccountLg"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_WISHLIST')}>
                        <Form.Item
                            name="enableWishlistLg"
                            valuePropName="checked">
                            <Switch
                                onChange={val =>
                                    this.toggleWishlist('desktop', val)
                                }
                            />
                        </Form.Item>
                    </RowLayout>

                    {this.state.isOpenWishlistLg && (
                        <RowLayout title={T('URL_WISHLIST')}>
                            <Form.Item name="wishlistUrl">
                                <Input
                                    addonBefore={window.config.rootUrl + '/'}
                                    placeholder={T('#')}
                                />
                            </Form.Item>
                        </RowLayout>
                    )}

                    <RowLayout title={T('ENABLE_CART')}>
                        <Form.Item name="enableCartLg" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ADDITIONAL_ELEMENT')}>
                        <Form.Item name="additionalElement">
                            <Input.TextArea
                                autoSize={{ minRows: 3 }}
                                placeholder={T('SUPPORT_SHORTCODE')}
                            />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_CAT_MENU')}>
                        <Form.Item
                            name="enableCategoriesMenuLg"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('OPEN_SUB_CAT_MENU_HOME')}>
                        <Form.Item
                            name="openCatMenuHome"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <Divider orientation="left">{T('MOBILE')}</Divider>

                    <RowLayout title={T('STYLE')}>
                        {headerMobiles.map(header => (
                            <div
                                className={`header-image-wrapper ${
                                    header.id == this.state.headerMobileStyle
                                        ? 'selected'
                                        : ''
                                }`}
                                style={{
                                    border: '2px solid #ddd'
                                }}
                                key={header.id}
                                onClick={() =>
                                    this.onChangeHeaderMobile(header.id)
                                }>
                                <img
                                    src={`${window.config.themeUrl}/manager/static/images/layout-header-xs/${header.id}.jpg`}
                                />
                            </div>
                        ))}
                    </RowLayout>

                    <RowLayout title={T('ENABLE_LOGO')}>
                        <Form.Item name="enableLogoXs" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_SEARCH_ICON')}>
                        <Form.Item
                            name="enableSearchXs"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_ACCOUNT')}>
                        <Form.Item
                            name="enableAccountXs"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_WISHLIST')}>
                        <Form.Item
                            name="enableWishlistXs"
                            valuePropName="checked">
                            <Switch
                                onChange={val =>
                                    this.toggleWishlist('mobile', val)
                                }
                            />
                        </Form.Item>
                    </RowLayout>

                    {this.state.isOpenWishlistXs && (
                        <RowLayout title={T('URL_WISHLIST')}>
                            <Form.Item name="wishlistUrl">
                                <Input
                                    addonBefore={window.config.rootUrl + '/'}
                                    placeholder={T('#')}
                                />
                            </Form.Item>
                        </RowLayout>
                    )}

                    <RowLayout title={T('ENABLE_CART')}>
                        <Form.Item name="enableCartXs" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <RowLayout title={T('ENABLE_CAT_MENU')}>
                        <Form.Item
                            name="enableCategoriesMenuXs"
                            valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </RowLayout>

                    <Divider orientation="left">{T('SEARCHING')}</Divider>

                    <RowLayout>
                        <Form.Item name="searchOnlyProduct">
                            <Radio.Group>
                                <Radio className="radio-y" value={true}>
                                    {T('SEARCH_ONLY_PRODUCTS')}
                                </Radio>
                                <Radio className="radio-y" value={false}>
                                    {T('SEARCH_EVERYTHING_ON_WEB')}
                                </Radio>
                            </Radio.Group>
                        </Form.Item>
                    </RowLayout>

                    <LoadingModal isOpen={this.state.isLoading} />
                </Container>
                <SaveButton T={T} />
            </Form>
        )
    }
}

const TopbarMenus = ({
    T,
    side = 'LEFT',
    menus = [],
    onOpenEdit,
    onRemove
}) => (
    <Card
        title={T(side)}
        type="inner"
        size="small"
        extra={
            <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => onOpenEdit(side, -1)}>
                {T('ADD')}
            </Button>
        }
        style={{ marginBottom: 24 }}>
        <Table
            pagination={false}
            dataSource={menus}
            rowKey={(record, index) => index}
            columns={[
                {
                    title: T('ICON'),
                    dataIndex: 'icon',
                    key: 'icon',
                    align: 'center',
                    render: (el, record) =>
                        record.icon ? (
                            <i className={`icon-${record.icon}`}></i>
                        ) : (
                            '-'
                        )
                },
                {
                    title: T('TEXT'),
                    dataIndex: 'title',
                    key: 'title'
                },
                {
                    title: T('URL'),
                    dataIndex: 'url',
                    key: 'url'
                },
                {
                    title: T('OPEN_NEW_TAB'),
                    dataIndex: 'isNewTab',
                    key: 'isNewTab',
                    align: 'center',
                    render: (el, record) =>
                        record.is_new_tab ? (
                            <CheckCircleTwoTone twoToneColor="#52c41a" />
                        ) : (
                            <CloseCircleTwoTone twoToneColor="#aaaaaa" />
                        )
                },
                {
                    dataIndex: 'action',
                    key: 'action',
                    render: (el, record, index) => (
                        <>
                            <Button
                                style={{
                                    marginRight: 5
                                }}
                                type="text"
                                shape="circle"
                                icon={<EditTwoTone />}
                                size="small"
                                onClick={() => onOpenEdit(side, index)}
                            />
                            <Popconfirm
                                placement="top"
                                title={T('CONFIRM_REMOVE_MENU_MSG')}
                                onConfirm={() => onRemove(side, index)}
                                okText={T('YES')}
                                cancelText={T('NO')}>
                                <Button
                                    danger
                                    type="text"
                                    shape="circle"
                                    icon={
                                        <DeleteTwoTone twoToneColor="#ff4d4f" />
                                    }
                                    size="small"
                                />
                            </Popconfirm>
                        </>
                    )
                }
            ]}
        />
    </Card>
)

export default HeaderGeneral
